import { useTheme } from '@mui/system';

interface HelpIconProps {
  height?: number;
  width?: number;
  fill?: string;
}

export const HelpIcon = ({ height = 32, width = 32, fill }: HelpIconProps) => {
  const theme = useTheme();
  const fillColor = fill || theme.palette.category.help;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <title>Help Icon</title>
      <path
        d="M16.0001 32.1316L11.3668 27.4983H7.00013C5.73346 27.4983 4.66124 27.0594 3.78346 26.1816C2.90569 25.3039 2.4668 24.2316 2.4668 22.965V4.96497C2.4668 3.69831 2.90569 2.62609 3.78346 1.74831C4.66124 0.870529 5.73346 0.431641 7.00013 0.431641H25.0001C26.2668 0.431641 27.339 0.870529 28.2168 1.74831C29.0946 2.62609 29.5335 3.69831 29.5335 4.96497V22.965C29.5335 24.2316 29.0946 25.3039 28.2168 26.1816C27.339 27.0594 26.2668 27.4983 25.0001 27.4983H20.6335L16.0001 32.1316ZM17.5668 17.0316C17.5668 16.365 17.6446 15.7928 17.8001 15.315C17.9557 14.8372 18.4112 14.2428 19.1668 13.5316C19.6557 13.065 20.0668 12.5483 20.4001 11.9816C20.7335 11.415 20.9001 10.7205 20.9001 9.89831C20.9001 8.52053 20.4335 7.47608 19.5001 6.76497C18.5668 6.05386 17.4557 5.69831 16.1668 5.69831C14.7224 5.69831 13.539 6.10942 12.6168 6.93164C11.6946 7.75386 11.0557 8.72053 10.7001 9.83164L13.9001 11.0316C14.0112 10.6539 14.2224 10.2205 14.5335 9.73164C14.8446 9.24275 15.3446 8.99831 16.0335 8.99831C16.4557 8.99831 16.7835 9.13164 17.0168 9.39831C17.2501 9.66497 17.3668 9.95386 17.3668 10.265C17.3668 10.5983 17.2446 10.9372 17.0001 11.2816C16.7557 11.6261 16.5224 11.8872 16.3001 12.065C15.3224 12.9761 14.7112 13.6761 14.4668 14.165C14.2224 14.6539 14.1001 15.6094 14.1001 17.0316H17.5668ZM15.8335 22.365C16.4112 22.365 16.9168 22.1483 17.3501 21.715C17.7835 21.2816 18.0001 20.7761 18.0001 20.1983C18.0001 19.5983 17.7835 19.0872 17.3501 18.665C16.9168 18.2428 16.4112 18.0316 15.8335 18.0316C15.2557 18.0316 14.7501 18.2428 14.3168 18.665C13.8835 19.0872 13.6668 19.5983 13.6668 20.1983C13.6668 20.7761 13.8835 21.2816 14.3168 21.715C14.7501 22.1483 15.2557 22.365 15.8335 22.365Z"
        fill={fillColor}
      />
    </svg>
  );
};
